import {
  DEVICE_MANAGEMENT_DATA_REQUEST,
} from "./actionTypes";
import { call, put, takeLatest } from "redux-saga/effects";
import { request } from "../apiConfig/api";
import { UrlConstants } from "../utils/ApiConstants";
import {
  deviceManagementDataFailure,
  deviceManagementDataSuccess,
} from "./actions";
import { authHeader } from "../utils/utils";

export function* getDeviceMangementData(): Generator {
  const requestOptions = {
    url: `${UrlConstants.BASE_URL}platform/api/devices/blueprint/{version}/deviceManagementDataTable`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: authHeader().Authorization,
    },
  };
  try {
    const result: any = yield call(request, requestOptions);
    yield put(deviceManagementDataSuccess(result));
  } catch (error) {
    yield put(deviceManagementDataFailure(error));
  }
}



function* saga() {
  yield takeLatest(DEVICE_MANAGEMENT_DATA_REQUEST, getDeviceMangementData);

}

export default saga;
